import { render, staticRenderFns } from "./WellsTable.vue?vue&type=template&id=727029d1&"
import script from "./WellsTable.vue?vue&type=script&lang=js&"
export * from "./WellsTable.vue?vue&type=script&lang=js&"
import style0 from "./WellsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports